import { render } from "./SemStep2Segmentation.vue?vue&type=template&id=3fc227f8&scoped=true"
import script from "./SemStep2Segmentation.vue?vue&type=script&lang=js"
export * from "./SemStep2Segmentation.vue?vue&type=script&lang=js"

import "./SemStep2Segmentation.vue?vue&type=style&index=0&id=3fc227f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc227f8"]])

export default __exports__